import { render, staticRenderFns } from "./PieChartChannelsCost.vue?vue&type=template&id=6c1ed2ab&"
import script from "./PieChartChannelsCost.vue?vue&type=script&lang=js&"
export * from "./PieChartChannelsCost.vue?vue&type=script&lang=js&"
import style0 from "./PieChartChannelsCost.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports